import classes from './CardGrey.module.css'

const CardGrey = ({children, minHeight, fullWidth}) => {
    return <div className={classes.card} style={{minHeight: minHeight, width: fullWidth ? '100%' : 'auto'}}>
        {children}
    </div>
}

export default CardGrey